export interface Language {
  code: string;
  name: string;
}

export const supportedLanguages: Language[] = [
  {
    code: 'en-GB',
    name: 'English (GB)',
  },
  {
    code: 'en-US',
    name: 'English (US)',
  },
  {
    code: 'de',
    name: 'Deutsch',
  }
];

export const supportedLanguagesCorpaylodging: Language[] = [
  {
    code: 'en-GB',
    name: 'English (GB)',
  },
  {
    code: 'en-US',
    name: 'English (US)',
  },
];

export const defaultLanguage = supportedLanguages[0].code;
